import {
    LOCALE_DE,
    LOCALE_DEBUG,
    LOCALE_ES,
    LOCALE_FR,
    LOCALE_GB,
    LOCALE_IT,
    LOCALE_PSEUDO,
    LOCALE_US,
} from '../locales/constants';
import type { Locale } from '../locales/constants';

type Pattern = {
    regex: RegExp;
    decimal: string;
    symbol: string;
    separator: string;
};

const patternByLocale: Record<Locale, Pattern> = {
    [LOCALE_US]: {
        regex: /\$(\s)?(\d+,)*\d+(\.\d+)?/g,
        decimal: '.',
        separator: ',',
        symbol: '$',
    },
    [LOCALE_PSEUDO]: {
        regex: /\$(\s)?(\d+,)*\d+(\.\d+)?/g,
        decimal: '.',
        separator: ',',
        symbol: '$',
    },
    [LOCALE_DEBUG]: {
        regex: /\$(\s)?(\d+,)*\d+(\.\d+)?/g,
        decimal: '.',
        separator: ',',
        symbol: '$',
    },
    [LOCALE_GB]: {
        regex: /\£(\s)?(\d+\.)*\d+(,\d+)?/g,
        decimal: ',',
        separator: '.',
        symbol: '£',
    },
    [LOCALE_DE]: {
        regex: /(\d+\.)*\d+(,\d+)?(\s)?€/g,
        decimal: ',',
        separator: '.',
        symbol: '€',
    },
    [LOCALE_FR]: {
        regex: /(\d+\s)*\d+(,\d+)?(\s)?€/g,
        decimal: ',',
        separator: ' ',
        symbol: '€',
    },
    [LOCALE_IT]: {
        regex: /(\d+\s)*\d+(,\d+)?(\s)?€/g,
        decimal: ',',
        separator: ' ',
        symbol: '€',
    },
    [LOCALE_ES]: {
        regex: /(\d+\s)*\d+(,\d+)?(\s)?€/g,
        decimal: ',',
        separator: '.',
        symbol: '€',
    },
};

export const getPriceAttr = (currency: string): string => {
    return `data-cms-price-${currency.toLocaleLowerCase()}`;
};

export const removePrices = (html: string): string => html.replace(/<price>(.*?)<\/price>/g, '$1');

export const replacePrices = (html: string, locale: Locale = 'en-US'): string => {
    const { regex } = patternByLocale[locale];
    const clean = removePrices(html);

    return clean.replace(regex, '<price>$&</price>');
};

export const sanitizePrice = (text: string, locale: Locale = 'en-US'): string => {
    const { regex, symbol, decimal, separator } = patternByLocale[locale];

    return text.replace(regex, match => {
        return match.replace(new RegExp(`[${separator + symbol}]`, 'g'), '').replace(decimal, '.');
    });
};
